import { render, staticRenderFns } from "./BedsManteiner.vue?vue&type=template&id=fd0feacc&"
import script from "./BedsManteiner.vue?vue&type=script&lang=js&"
export * from "./BedsManteiner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports